import {Component, Input} from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {TextModal} from "../../../modelo/modals/text-modal";

@Component({
  selector: 'app-modals-universal',
  templateUrl: './modals-universal.component.html',
  styleUrls: ['./modals-universal.component.css']
})
export class ModalsUniversalComponent  {

  @Input() textModals:TextModal[];

  constructor(public activeModal: NgbActiveModal) {
    this.textModals=[];
  }



}
